import React, {useState} from 'react'
import {Attendee} from 'Event/attendee'
import SelectTestAttendeeDialog from 'organization/Event/Form/TestTagButton/SelectTestAttendeeDialog'
import {Service, ServiceTag} from 'organization/Event/Services/ServicesProvider'
import Button from 'lib/ui/Button'
import styled from 'styled-components'

export default function TestTagButton<T extends ServiceTag>(props: {
  tag: T | null
  integration: Service
  addTag: (tag: T, attendee: Attendee) => Promise<void>
}) {
  const {tag, addTag, integration} = props
  const [isVisible, setIsVisible] = useState<boolean>(false)

  const toggleVisible = () => {
    setIsVisible((current) => !current)
  }

  const onSelect = async (attendee: Attendee | null) => {
    if (!attendee || !tag) {
      return
    }

    return addTag(tag, attendee)
  }

  if (!tag) {
    return null
  }

  return (
    <>
      <SelectTestAttendeeDialog
        visible={isVisible}
        onClose={toggleVisible}
        onSelect={onSelect}
        integration={integration}
      />
      <StyledButton variant="outlined" color="primary" onClick={toggleVisible}>
        Test tag
      </StyledButton>
    </>
  )
}

const StyledButton = styled(Button)`
  margin-top: 18px;
  height: 56px;
`
